var exports = {
  "zb": "expand-button-line__EXrygN",
  "S8": "expand-up-and-down__L2NgSU",
  "DQ": "expand-button-unified__N1ciuZ",
};

module.exports = exports;
